import { CForm, CCol, CFormInput, CFormLabel, CFormSelect } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useLoading } from "../Loading";
import { Button } from "@mui/material";
import { ref, uploadBytes } from "firebase/storage";
import db, { storage } from "../../firebase/firebaseConfig";
import { useAuth } from "../../contexts/authContext";
import { addDoc, collection } from "firebase/firestore";
import {  useNavigate } from "react-router-dom";

function AddNewPet() {

    const { setLoading } = useLoading();
    const [image, setImage] = useState();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [petData, setPetData] = useState({
        petName: "",
        age: "",
        breed: "",
        colour: "",
        gender: "",
        location: "",
        size: "",
        status: "Available",
    });
    const malaysiaStates = [
        "Johor",
        "Kedah",
        "Kelantan",
        "Malacca",
        "Negeri Sembilan",
        "Pahang",
        "Perak",
        "Perlis",
        "Penang",
        "Sabah",
        "Sarawak",
        "Selangor",
        "Terengganu",
        "Kuala Lumpur",
    ];

    const dogBreeds = [
        "Golden Retriever", "Labrador Retriever", "German Shepherd", "Poodle", "Beagle",
        "Rottweiler", "Shih Tzu", "Maltese", "Siberian Husky", "Doberman Pinscher",
        "Golden Doodle", "Pomeranian", "Yorkshire Terrier", "French Bulldog", "Dachshund",
        "Boxer", "Australian Shepherd", "Miniature Schnauzer", "Chihuahua", "Bulldog",
    ];

    const catBreeds = [
        "Persian", "Siamese", "Maine Coon", "British Shorthair", "Ragdoll",
        "Bengal", "Sphynx", "American Shorthair", "Scottish Fold", "Munchkin",
    ];

    const otherBreeds = [

        "Parakeet", "Canary", "Finch", "Syrian Hamster", "Dwarf Hamster", "Ball Python", "Corn Snake", "Chinchillas", 
        "Guinea Pigs", "Ferrets", "Turtles", "Rabbits", "Hedgehogs", "Sugar Gliders", "Macaws", "Cockatoos",
        "Lovebirds",  "Geckos", "Iguanas", "Bearded Dragons"

    ];

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 50);
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file)); // Generate preview URL
            setPetData({ ...petData, image: file });
        }
        else {
            setImage(""); // Generate preview URL
            setPetData({ ...petData, image: "" });
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if(!image)
            {
                alert("Please upload the image for pet.");
                return;
            }
        setLoading(true);
        try {
            const fileExtension = petData.image.name.split('.').pop();
            const newFileName = `${currentUser.uid}_${Date.now()}.${fileExtension}`;
            const updatedData = { ...petData, image: newFileName };
            const storageRef = ref(storage, `AdoptPets/${newFileName}`);
            await uploadBytes(storageRef, petData.image);
            console.log("upload success");

            await addDoc(collection(db, "Pets"), { ...updatedData, shelterId: currentUser.uid});
            
            setLoading(false);
            alert("Added Successfully")
            navigate('/shelter-pet-list', {replace:true});

            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function(){
                window.history.pushState(null, "", window.location.href);
            }

        }
        catch (error) {
            setLoading(false);
            console.error(error);
        }

    };

    return (
        <div className="newPetContainer">
            <h1>Add New Pet</h1>
            <div className="petForm">
                <CForm className="row g-3" onSubmit={handleSubmit}>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputName" className="formLabel">Pet Name</CFormLabel>
                        <CFormInput id="inputName" value={petData.petName} required
                            onChange={(e) => setPetData({ ...petData, petName: e.target.value })} />
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputType" className="formLabel">Pet Type</CFormLabel>
                        <CFormSelect id="inputType" value={petData.petType} required
                            onChange={(e) => setPetData({ ...petData, petType: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Dog">Dog</option>
                            <option value="Cat">Cat</option>
                            <option value="Other">Other</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputBreed" className="formLabel">Breed</CFormLabel>
                        <CFormSelect
                            id="inputBreed"
                            value={petData.breed}
                            required
                            onChange={(e) => setPetData({ ...petData, breed: e.target.value })}>
                            <option value="">Choose...</option>
                            {petData.petType === 'Dog' && dogBreeds.map((breed) => (
                                <option key={breed} value={breed}>{breed}</option>
                            ))}
                            {petData.petType === 'Cat' && catBreeds.map((breed) => (
                                <option key={breed} value={breed}>{breed}</option>
                            ))}
                            {petData.petType === 'Other' && otherBreeds.map((breed) => (
                                <option key={breed} value={breed}>{breed}</option>
                            ))}
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputColour" className="formLabel">Colour</CFormLabel>
                        <CFormSelect id="inputColour" value={petData.colour} required
                            onChange={(e) => setPetData({ ...petData, colour: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Black">Black</option>
                            <option value="Gray">Gray</option>
                            <option value="White">White</option>
                            <option value="Green">Green</option>
                            <option value="Cream">Cream</option>
                            <option value="Gold">Gold</option>
                            <option value="Orange">Orange</option>
                            <option value="Beige">Beige</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputLocation" className="formLabel">Location</CFormLabel>
                        <CFormSelect id="inputLocation" value={petData.location} required
                            onChange={(e) => setPetData({ ...petData, location: e.target.value })}>
                            <option value="">Choose...</option>
                            {malaysiaStates.map(state => (
                                <option key={state} value={state}>{state}</option>
                            ))}
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputGender" className="formLabel">Gender</CFormLabel>
                        <CFormSelect id="inputGender" value={petData.gender} required
                            onChange={(e) => setPetData({ ...petData, gender: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Female">Female</option>
                            <option value="Male">Male</option>
                        </CFormSelect>
                    </CCol>

                    <CCol md={12}>
                        <CFormLabel htmlFor="inputAge" className="formLabel">Age</CFormLabel>
                        <CFormSelect id="inputAge" value={petData.age} required
                            onChange={(e) => setPetData({ ...petData, age: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Baby">Baby</option>
                            <option value="Young">Young</option>
                            <option value="Adult">Adult</option>
                            <option value="Senior">Senior</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inpuSize" className="formLabel">Size</CFormLabel>
                        <CFormSelect id="inputSize" value={petData.size} required
                            onChange={(e) => setPetData({ ...petData, size: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Baby">Baby</option>
                            <option value="Small">Small</option>
                            <option value="Medium">Medium</option>
                            <option value="Large">Large</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="imageUpload" className="formLabel">Upload Profile Picture</CFormLabel>
                        <CFormInput type="file" id="imageUpload" accept="image/*" onChange={handleImageChange} required />

                        {image && (
                            <div style={{ marginTop: "10px" }}>
                                <img src={image} alt="Preview" style={{ width: "150px", height: "150px", borderRadius: "10px", objectFit: "cover" }} />
                            </div>
                        )}
                    </CCol>
                   
                    <CCol md={12}>
                        <Button type="submit" className="postBtn">Save</Button>
                    </CCol>
                </CForm>
            </div>
        </div>
    );
}

export default AddNewPet;